const Immutable = require('seamless-immutable');
const dishMenuReducer = require('../dish-menu/index.js');
const dishHelper = require('../../helper/dish-helper');
const updateSyncShoppingCart = require('../../helper/order-dinner-helper').updateSyncShoppingCart;
const combineReducers = require('redux').combineReducers;
import ReducerContainer from '../../helper/reducer-helper';
import commonReducer from '../../reducer/common/index';

const reducerContainer = ReducerContainer.create();

const dishMenuZcReducer = function (
  state = Immutable.from({
    callMsg:{
      info:'',
      callStatus:false,
    },
    userOrderedDishList: [],
    callAble:true,
    serviceStatus:{},
    userInfo: null,
    authInfo: null,
    toastProps: null,
    notices: [],
    tableAreaInfo: {},
    guidStatus: false,
    isDataInitOver: false,
    saveOrderChangeItem: null,
    mustOrderDishList: [],
    selfChooseDishList: [],
    shopMinConsume: null,
  }),
  action
) {
  const { type, payload } = action;

  if (reducerContainer.exist(type)) {
    return reducerContainer.getNextState(type, state, payload);
  }

  switch (type) {
    case 'SET_CALL_MSG': {
      return state.set('callMsg', payload || {});
    }
    case 'SET_CANCEL_CALL_MSG': {
      return state.set('callMsg', payload || {});
    }
    case 'SET_CAN_CALL': {
      return state.set('callAble', payload);
    }
    case 'SET_SERVICE_STATUS': {
      const serviceStatus = payload || {};
      if (!serviceStatus.peopleCount && sessionStorage.orderDinnerCartPersonCount) {
        // 之前在购物车页选择过人数，使用选择的人数
        serviceStatus.peopleCount = sessionStorage.orderDinnerCartPersonCount;
      }
      return state.set('serviceStatus', serviceStatus);
    }
    case 'SET_GUID_STATUS':
      return state.set('guidStatus', payload);

    case 'SET_USER_INFO' : {
      return state.set('userInfo', payload);
    }
    case 'SET_AUTH_INFO':
      return state.set('authInfo', payload);
    case 'SET_TOAST_PROPS':
      return state.set('toastProps', payload);
    case 'SET_ORDER_NOTICE':
      return state.set('notice', payload);
    case 'SET_TABLE_AREA_INFO':
      return state.set('tableAreaInfo', payload);
    case 'SET_DATA_INIT_OVER':
      return state.set('isDataInitOver', payload);
    case 'CHANGE_DISH':
      return state.set('saveOrderChangeItem', payload);
    case 'REINSTATE_UNDEFINED':
      return state.set('saveOrderChangeItem', null);
    case 'CLEAR_SAVE_ORDER':
      return state.set('saveOrderChangeItem', 'clearAll');
    case 'SET_MUST_ORDER_DISH_LIST': {
      const must = payload.filter(item => item.strategyType !== 3);
      const self = payload.filter(item => item.strategyType === 3);

      return state.set('mustOrderDishList', must).set('selfChooseDishList', self);
    }
    case 'SET_SHOP_MIN_CONSUME': {
      return state.set('shopMinConsume', payload);
    }
    default:
      return state;
  }
};

reducerContainer.add('SYNC_SHOPPING_CART', (state, payload) => state.set('userOrderedDishList', payload));

reducerContainer.add('ADD_ORDER_NOTICE', (state, payload = {}) => {
  // 设置必点菜属性
  payload.orderDishes = dishHelper.setDishListMustOrderProps(payload.orderDishes, state.mustOrderDishList.concat(state.selfChooseDishList));
  const { userInfo, isOther, orderDishes, increment = 1 } = payload;
  const [dish] = orderDishes;
  const flag = `${userInfo.addOperation ? '+' : ''}${increment}`;
  const nextState = updateSyncShoppingCart(state, payload);

  if (isOther) {
    const notice = Object.assign({
      dishCount: dishHelper.getDishesCount([dish]),
      readed: false,
      dishName: dish.name,
      orderAction: flag,
    }, payload.userInfo);
    return nextState.update('notices', notices => notices.concat([notice])).set('updateSyncShoppingCart', payload);
  }

  return nextState.set('updateSyncShoppingCart', payload);
});

reducerContainer.add('READ_ORDER_NOTICE', (state, payload) => {
  let updated = false;
  return state.update('notices', (notices = []) =>
    notices.flatMap((notice = {}, index) => {
      const readed = notice.readed === true;
      if (!readed && !updated) {
        updated = true;
        return notice.set('readed', true);
      }
      return notice;
    }));
});

module.exports = combineReducers({
  dishMenuReducer,
  dishMenuZcReducer,
  common: commonReducer,
});



// WEBPACK FOOTER //
// ./src/reducer/dish-menu-zc/index.js